// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const approverSchema = z.object({
  "admin_user_id": z.string().uuid(),
  "email": z.string(),
  "name": z.string(),
  "role": z.string(),
  "source_org_id": z.string().uuid().optional(),
  "source_org_name": z.string().optional(),
  "source_grant_id": z.string().uuid().optional(),
  "scope": z.enum(["tenant", "tenant_grant", "managed_provider", "org"]),
  "in_routing_pool": z.boolean()
});

export const listApproversResponseSchema = z.object({
  "data": z.array(approverSchema),
  "pool_mode": z.enum(["all", "subset"]),
  "pool_member_ids": z.array(z.string().uuid())
});

export const decisionAvailabilitySchema = z.object({
  "allowed": z.boolean(),
  "reason": z.string().optional()
});

export const queueEntrySchema = z.object({
  "Kind": z.enum(["recovery", "access"]),
  "ID": z.string().uuid(),
  "TenantID": z.string().uuid(),
  "SubjectUserID": z.string().uuid(),
  "SubjectEmail": z.string(),
  "SubjectDisplayName": z.string(),
  "SubjectStatus": z.string(),
  "ApplicationID": z.string().uuid().nullable().optional(),
  "ApplicationName": z.string(),
  "AccessType": z.string(),
  "DurationMinutes": z.number().int(),
  "ExpiresAt": z.string().nullable().optional(),
  "GrantExpiresAt": z.string().nullable().optional(),
  "GrantExists": z.boolean().default(false),
  "Reason": z.string(),
  "Status": z.string(),
  "NRequiredApprovals": z.number().int(),
  "ActiveStageIndex": z.number().int().default(0),
  "StageCount": z.number().int().default(1),
  "TotalRequiredApprovals": z.number().int().default(0),
  "decision_comment": z.string().default(""),
  "decided_by": z.string().default(""),
  "RequestedAt": z.string(),
  "RequestedBy": z.string().uuid().nullable().optional(),
  "EscalatesAt": z.string().nullable().optional(),
  "ApproveCount": z.number().int(),
  "DenyCount": z.number().int(),
  "NeedsInfoCount": z.number().int(),
  "CommentCount": z.number().int(),
  "Priority": z.enum(["critical", "high", "normal"]),
  "SLABucket": z.enum(["overdue", "due_today", "this_week", "fresh"]),
  "is_first_request_ever": z.boolean().nullable().optional(),
  "is_first_request_for_app": z.boolean().nullable().optional(),
  "peer_count_with_app": z.number().int().nullable().optional(),
  "submitted_outside_hours": z.boolean().nullable().optional(),
  "recent_denial_count": z.number().int().nullable().optional(),
  "subject_title": z.string().default(""),
  "subject_department": z.string().default(""),
  "subject_manager": z.string().default(""),
  "decision_availability": decisionAvailabilitySchema.optional()
});

export const queueResponseSchema = z.object({
  "data": z.array(queueEntrySchema),
  "pagination": z.object({
    "total": z.number().int(),
    "offset": z.number().int(),
    "limit": z.number().int()
  })
});
